import axios from '../Util/AxiosIntercepted';

/*
{
    query:"
        mutation ($room: NewRoom!) {
            createRoom(room: $room) {
                creator {
                userId
                username
            }
            name
            roommates {
                role
                id {
                    roomId
                    userId
            }
            banned
            }
            roomId
            url
        }
        }",

    variables:{"room":{"creator":{"userId":"14512"},"name":"Stephen King Discussion3","url":"fhuw8AEkl"}}}
*/

function getImageBlob(roomId, fileName) {
    return axios
        // .get(`${process.env.REACT_APP_API_HOST}/vyu/api/v1/presentation-item?filename=${fileName}&roomId=${roomId}`, {
        .get(`/vyu/api/v1/presentation-item?filename=${fileName}&roomId=${roomId}`, {
            responseType: 'blob'
        })
        .then(({ data }) => data)
        .catch(async (e) => {
            // When responseType is 'blob', error response data is also a Blob
            // We need to read it as text to get the error message
            let errorMessage = 'Failed to load image';
            if (e.response?.data instanceof Blob) {
                try {
                    const text = await e.response.data.text();
                    const json = JSON.parse(text);
                    errorMessage = json.message || errorMessage;
                } catch (parseError) {
                    errorMessage = e.message || errorMessage;
                }
            } else if (e.response?.data?.message) {
                errorMessage = e.response.data.message;
            } else if (e.message) {
                errorMessage = e.message;
            }
            throw new Error(errorMessage);
        });
}

// onUploadProgress is axios's: it fires as the request body goes out, with
// { loaded, total }. It says nothing about the server's work after that - a PDF
// or Office file is still being converted into slides once every byte is sent.
function uploadImage(roomId, index, formData, { onUploadProgress } = {}) {
    // TODO: set back to /vyu
    // const url = `${process.env.REACT_APP_API_HOST}/vyu/api/v1/presentation-item?roomId=${roomId}&index=${index}`;
    const url = `/vyu/api/v1/presentation-item?roomId=${roomId}&index=${index}`;
    return axios.post(url, formData, { onUploadProgress }).catch((e) => {
        const message = e.response?.data?.message || e.message || 'Failed to upload image';
        throw new Error(message);
    });
}

function deleteImage(roomId, fileName) {
    return axios
        // .delete(`${process.env.REACT_APP_API_HOST}/vyu/api/v1/presentation-item?filename=${fileName}&roomId=${roomId}`)
        .delete(`/vyu/api/v1/presentation-item?filename=${fileName}&roomId=${roomId}`)
        .catch((e) => {
            const message = e.response?.data?.message || e.message || 'Failed to delete image';
            throw new Error(message);
        });
}

export default {
    getImageBlob,
    deleteImage,
    uploadImage
};
